import template from './wizard_holidays.html';

class WizardHolidayViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
	};

	close()
	{
		this.dialog.close();
	};

	back_wizard()
	{
		Grape.dialog.open('WizardEmployeeFieldsEntry', {});
		this.dialog.close();
	};

	next_wizard()
	{
		Grape.dialog.open('WizardLeaveTypesEntry', {});
		this.dialog.close();
	};
};

class WizardHolidayPage
{
	constructor (bindings)
	{
		this.bindings = bindings;
		this.viewModel = new WizardHolidayViewModel(this);
	};

	init()
	{
		document.title = 'Add/Edit Holidays';
	};
};

export default {
	name: 'WizardHolidayEntry',
	dialog_class: WizardHolidayPage,
	template: template,
	template_filename: 'translation/dialogs/wizard_holidays',
	provider: 'ps'
};
